import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { TicketsHttpService } from './tickets-http.service';
import { AskTicketsActions } from './tickets.state';

@Injectable({ providedIn: 'root' })
export class AskTicketsEffects {
  private readonly actions$ = inject(Actions);
  private readonly templatesHttpService = inject(TicketsHttpService);

  public createTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AskTicketsActions.createOnePessimistic),
      switchMap(({ payload: { data, correlationId } }) =>
        this.templatesHttpService.createTicket(data).pipe(
          map(data =>
            AskTicketsActions.createOnePessimisticSuccess({ payload: { data, correlationId } }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(AskTicketsActions.createOnePessimisticFailed({ payload: { error, correlationId } })),
          ),
        ),
      ),
    ),
  );

  public fetchOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AskTicketsActions.fetchOne),
      switchMap(({ payload: { id } }) =>
        this.templatesHttpService.fetchOne(id).pipe(
          map(data => AskTicketsActions.fetchOneSuccess({ payload: { data } })),
          catchError((error: HttpErrorResponse) =>
            of(AskTicketsActions.fetchOneFailed({ payload: { error, id } })),
          ),
        ),
      ),
    ),
  );

  public updateTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AskTicketsActions.updateOnePessimistic),
      switchMap(({ payload: { id, data } }) =>
        this.templatesHttpService.updateTicket(id, data).pipe(
          map(data => AskTicketsActions.updateOnePessimisticSuccess({ payload: { data } })),
          catchError((error: HttpErrorResponse) =>
            of(AskTicketsActions.updateOnePessimisticFailed({ payload: { error, data: { id } } })),
          ),
        ),
      ),
    ),
  );

  public moveTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AskTicketsActions.move),
      switchMap(({ payload: { data, id } }) =>
        this.templatesHttpService.moveTicket(id, data).pipe(
          map(data => AskTicketsActions.moveSuccess({ payload: { data } })),
          catchError((error: HttpErrorResponse) =>
            of(AskTicketsActions.moveFailed({ payload: { error, data: { id } } })),
          ),
        ),
      ),
    ),
  );

  public cancelTicket$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AskTicketsActions.cancel),
      switchMap(({ payload: { id } }) =>
        this.templatesHttpService.cancelTicket(id).pipe(
          map(data => AskTicketsActions.cancelSuccess({ payload: { data } })),
          catchError((error: HttpErrorResponse) =>
            of(AskTicketsActions.cancelFailed({ payload: { error, data: id } })),
          ),
        ),
      ),
    ),
  );
}
